 ///////////////////////////////////character
 //this array is immediately overwritten in app.js when grabHero('thor'), grabHero('magneto') etc is called
 export const initialCharacterDatabaseState = {
    result:1,
    lastValues: [],
    characterDatabaseList:[],
    readyToShowCharacters:false
}

export const characterDatabaseReducer = (state = initialCharacterDatabaseState,action) => {
    //in this functions case, 'payload' is an array so we access the ata like below
    switch(action.type){
        case "CHANGE-CHARACTER-DATABASE":
        state = {
            ...state,//this will grab everything from the previous state
            characterDatabaseList: action.payload

        };
        return state;
        
        case "SHOW-DATABASE-CHARACTERS":
        state = {
            ...state,//this will grab everything from the previous state
            readyToShowCharacters: action.payload
            
        };
        return state;
    }
    //reducers always have to return some sort of state
   // console.log(state);
    return state;
};



// WEBPACK FOOTER //
// ./src/reducers/characterDatabaseReducer.js